import React from 'react'
import {Button, Panel} from 'react-bootstrap'

export default class DataPanel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: true
    };
  }

  generateErrorOrWarning() {
    const elements = [
      'db_last_upload',
      'audits_last_updated',
      'unprocessed_audits',
      'failed_job_count',
      'thumbnail_last_updated',
      'video_last_updated',
      'vimeo_last_updated'
    ]
    const res = {}
    elements.forEach(ele => (res[ele] = (this._getKlassName(ele) || 'default')))
    return res
  }

  _getKlassName(ele) {
    const data = this.props.data;
    switch(ele) {
      case 'db_last_upload':
        if(data.db_backup.delay>1) {
          return 'danger'
        }else {
          return
        }
      case 'audits_last_updated':
        if(data.audits.delay>12) {
          return 'danger'
        }else if(data.audits.delay>2) {
          return 'warning'
        }else {
          return
        }
      case 'unprocessed_audits':
        if(data.audits.unprocessed_audits >= 1000) {
          return 'danger'
        }else if(data.audits.unprocessed_audits>=100) {
          return 'warning'
        }else {
          return
        }
      case 'failed_job_count':
        if(data.delayed_jobs.failed_jobs>10) {
          return 'danger'
        }else if(data.delayed_jobs.failed_jobs>4) {
          return 'warning'
        }else {
          return
        }
      case 'thumbnail_last_updated':
        if(data.screenshot_thumbnails.delay>24) {
          return 'danger'
        }else if(data.screenshot_thumbnails.delay>4) {
          return 'warning'
        }else {
          return
        }
      case 'video_last_updated':
        if(data.video_upload.delay>4) {
          return 'danger'
        }else if(data.video_upload.delay>2) {
          return 'warning'
        }else {
          return
        }
      case 'vimeo_last_updated':
        if(data.vimeo_links.delay>10) {
          return 'danger'
        }else if(data.vimeo_links.delay>4) {
          return 'warning'
        }else {
          return
        }
      default:
        return;
    }
  }

  _getPanelKlassName(errorOrWarning) {
    let values = Object.values(errorOrWarning)
    if(values.includes('danger')) {
      return 'danger'
    }else if(values.includes('warning')) {
      return 'warning'
    }else {
      ''
    }
  }

  render() {
    const data = this.props.data;
    const errorOrWarning = this.generateErrorOrWarning();
    const panelKlassName = this._getPanelKlassName(errorOrWarning);

    return (
      <div className='DataPanel'>
        <Panel id="collapsible-panel-example-2" defaultExpanded={this.state.open} bsStyle={panelKlassName}>
          <Panel.Heading>
            <Panel.Title toggle>
              OPERATIONS DATA
            </Panel.Title>
          </Panel.Heading>
          <Panel.Collapse>
            <Panel.Body>
              <h6 className='title'>DATABASE BACKUP (S3)</h6>
              <dl className="dl-horizontal">
                <dt className={`text-${errorOrWarning.db_last_upload}`}>
                  Last Uploaded :
                </dt>
                <dd className={`text-${errorOrWarning.db_last_upload}`}>{data.db_backup.last_created}</dd>

                <dt>Key :</dt>
                <dd>{data.db_backup.key}</dd>
              </dl>
<hr />
              <h6 className='title'>AUDITS</h6>
              <dl className="dl-horizontal">
                <dt className={`text-${errorOrWarning.audits_last_updated}`}>
                  Last Updated :
                </dt>
                <dd className={`text-${errorOrWarning.audits_last_updated}`}>{data.audits.last_audit_updated}</dd>

                <dt className={`text-${errorOrWarning.unprocessed_audits}`}>Unprocessed Audits :</dt>
                <dd className={`text-${errorOrWarning.unprocessed_audits}`}>{data.audits.unprocessed_audits}</dd>
              </dl>
<hr />
              <h6 className='title'>DELAYED JOBS</h6>
              <dl className="dl-horizontal">
                <dt className={`text-${errorOrWarning.failed_job_count}`}>
                  Failed Job Count :
                </dt>
                <dd className={`text-${errorOrWarning.failed_job_count}`}>{data.delayed_jobs.failed_jobs}</dd>
              </dl>
<hr />
              <h6 className='title'>SCREENSHOT THUMBNAILS</h6>
              <dl className="dl-horizontal">
                <dt className={`text-${errorOrWarning.thumbnail_last_updated}`}>
                  Last Updated :
                </dt>
                <dd className={`text-${errorOrWarning.thumbnail_last_updated}`}>{data.screenshot_thumbnails.last_updated}</dd>
              </dl>
<hr />
              <h6 className='title'>VIDEO UPLOADS (S3)</h6>
              <dl className="dl-horizontal">
                <dt className={`text-${errorOrWarning.video_last_updated}`}>
                  Last Updated :
                </dt>
                <dd className={`text-${errorOrWarning.video_last_updated}`}>{data.video_upload.last_updated}</dd>
                <dt>
                  Key :
                </dt>
                <dd>{data.video_upload.key}</dd>
              </dl>
<hr />
              <h6 className='title'>VIMEO LINKS</h6>
              <dl className="dl-horizontal">
                <dt className={`text-${errorOrWarning.vimeo_last_updated}`}>
                  Last Updated :
                </dt>
                <dd className={`text-${errorOrWarning.vimeo_last_updated}`}>{data.vimeo_links.last_updated}</dd>
              </dl>
            </Panel.Body>
          </Panel.Collapse>
        </Panel>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/admin/statuses/javascripts/components/Operations/DataPanel.jsx